// extracted by mini-css-extract-plugin
export var chip = "_qg-2";
export var chipBody = "_qg-8";
export var chipHeader = "_qg-9";
export var chipWithKind = "_qg-7";
export var icon = "_qg-3";
export var kind = "_qg-a";
export var remove = "_qg-5";
export var removeIcon = "_qg-6";
export var row = "_qg-0";
export var rowHistorical = "_qg-1";
export var text = "_qg-4";